/**
 * Created by Lorenz.Padberg@iterativ.ch on 09.05.17.
 * Copyright (c) 2017 Iterativ GmbH. All rights reserved
 */

import {Notification} from './notifications.models';
import {NotificationsActionTypes} from './notifications.actions';
import {CustomAction} from '../actions/CustomAction';

export interface NotificationsState {
  notifications: Notification[];  // used in the sidebar
  pageNotifications: Notification[]; // used on the notification page
  notificationsLoading: boolean;
  newNotifications: boolean;
  lastestNotificationId: number;
  error: string;
}

const initialNotificationsState: NotificationsState = {
  notifications: [],
  pageNotifications: [],
  newNotifications: false,
  lastestNotificationId: -1,
  notificationsLoading: false,
  error: null
};


function newNotificationAvailable(currentFlag, lastestNotificationId, filteredNotifications) {
  if (filteredNotifications.length === 0) {
    return false;
  }
  return currentFlag || (lastestNotificationId !== -1 && filteredNotifications[0].id > lastestNotificationId)
}

export function reducer(state = initialNotificationsState, action: CustomAction): NotificationsState {
  switch (action.type) {

    case NotificationsActionTypes.NOTIFICATIONS_GET_NOTIFICATIONS:
    case NotificationsActionTypes.NOTIFICATIONS_GET_NOTIFICATIONS_FOR_PAGE:
      return Object.assign({}, state,
        {
          notificationsLoading: true
        }
      );

    case NotificationsActionTypes.NOTIFICATIONS_GET_NOTIFICATIONS_SUCCESS:

      return Object.assign({}, state,
        {
          notifications: action.payload,
          newNotifications: newNotificationAvailable(state.newNotifications, state.lastestNotificationId, action.payload),
          error: null,
          notificationsLoading: false
        }
      );

    case NotificationsActionTypes.NOTIFICATIONS_GET_NOTIFICATIONS_FOR_PAGE_SUCCESS:

      // const filteredNotificationsForPage = filterInvalidNotifications(action.payload)

      return Object.assign({}, state,
        {
          pageNotifications: action.payload,
          notifications: action.payload.slice(0, 5),
          newNotifications: false,
          error: null,
          notificationsLoading: false
        }
      );

    case NotificationsActionTypes.NOTIFICATIONS_GET_NOTIFICATIONS_FAIL:
    case NotificationsActionTypes.NOTIFICATIONS_GET_NOTIFICATIONS_FOR_PAGE_FAIL:
      return Object.assign({}, state,
        {
          notificationsLoading: false
        }
      );

    case NotificationsActionTypes.NOTIFICATIONS_UNSET_NEW_NOTIFICATIONS:
      return Object.assign({}, state,
        {
          newNotifications: false
        }
      );

    case NotificationsActionTypes.NOTIFICATIONS_SET_LATEST_ID:
      const newNotifications = state.newNotifications || (action.payload !== -1 && state.lastestNotificationId !== -1 && state.lastestNotificationId !== action.payload);

      return Object.assign({}, state, {
        newNotifications: newNotifications,
        lastestNotificationId: action.payload
      });

    case NotificationsActionTypes.NOTIFICATIONS_MARK_NOTIFICATIONS:

      let index = state.notifications
        .map(notification => notification.id)
        .indexOf(action.payload);

      // return if already marked as read
      // or if notification is from page notifications <- will be reloaded when user navigates on page
      if (index < 0 || !state.notifications[index].unread) {
        return state;
      }

      let newNotification = Object.assign({}, state.notifications[index], {
        unread: false
      });

      return Object.assign({}, state, {
        notifications: [
          ...state.notifications.slice(0, index),
          newNotification,
          ...state.notifications.slice(index + 1)
        ]
      });

    case NotificationsActionTypes.NOTIFICATIONS_SET_ERROR:
      return Object.assign({}, state, {
        error: action.payload
      });

    case NotificationsActionTypes.NOTIFICATIONS_GET_OFFLINE_NOTIFICATIONS_FOR_PAGE:
      return Object.assign({}, state, {
        pageNotifications: state.notifications,
        notificationsLoading: false
      });

    case NotificationsActionTypes.NOTIFICATIONS_RESET:
      return Object.assign({}, initialNotificationsState);

    default: {
      return state;
    }
  }
}

// getters for state members

export function getNotifications(state: NotificationsState) {
  return state.notifications;
}

export function getNewNotifications(state: NotificationsState) {
  return state.newNotifications;
}

export function getPageNotifications(state: NotificationsState) {
  return state.pageNotifications;
}

export function getNotificationsError(state: NotificationsState) {
  return state.error;
}

export function getLatestNotificationId(state: NotificationsState) {
  return state.lastestNotificationId;
}

export function getNotificationsLoading(state: NotificationsState) {
  return state.notificationsLoading;
}


